// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CoverMyMedsInboundPriorAuthorizationProcessStatusRequestModel {
    static getAttributeTypeMap() {
        return CoverMyMedsInboundPriorAuthorizationProcessStatusRequestModel.attributeTypeMap;
    }
}
CoverMyMedsInboundPriorAuthorizationProcessStatusRequestModel.discriminator = undefined;
CoverMyMedsInboundPriorAuthorizationProcessStatusRequestModel.additionalProperties = false;
CoverMyMedsInboundPriorAuthorizationProcessStatusRequestModel.attributeTypeMap = [
    {
        "name": "patient_identifier",
        "baseName": "patient_identifier",
        "type": "string"
    },
    {
        "name": "patient_last_name",
        "baseName": "patient_last_name",
        "type": "string"
    },
    {
        "name": "pa_status",
        "baseName": "pa_status",
        "type": "string"
    },
    {
        "name": "pa_key",
        "baseName": "pa_key",
        "type": "string"
    },
    {
        "name": "drug_name",
        "baseName": "drug_name",
        "type": "string"
    },
    {
        "name": "quantity",
        "baseName": "quantity",
        "type": "string"
    },
    {
        "name": "days_supply",
        "baseName": "days_supply",
        "type": "string"
    },
    {
        "name": "pa_expiration_date",
        "baseName": "pa_expiration_date",
        "type": "string"
    },
    {
        "name": "appeal_of",
        "baseName": "appeal_of",
        "type": "string"
    },
    {
        "name": "appeals",
        "baseName": "appeals",
        "type": ""
    },
    {
        "name": "is_outreach_exhausted",
        "baseName": "is_outreach_exhausted",
        "type": "boolean"
    },
    {
        "name": "external_pa_identifier",
        "baseName": "external_pa_identifier",
        "type": "string"
    },
];
//# sourceMappingURL=coverMyMedsInboundPriorAuthorizationProcessStatusRequestModel.js.map